class SaveUserAccessOrderDto {
  companyName!: string;
  additionalAccreditationQuantity!: number;
  vipParkingQuantity!: number;
  standardParkingQuantity!: number;
  presaleTicketQuantity!: number;
}

export default SaveUserAccessOrderDto;
